/**
 * usePopover — abre/fecha um popover/menu com Escape, clique fora e retorno de
 * foco ao acionador. Listeners só existem enquanto aberto (limpos ao fechar).
 */
import { useCallback, useEffect, useRef, useState } from 'react';

export function usePopover() {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef(null);
  const panelRef = useRef(null);

  const close = useCallback((devolverFoco = true) => {
    setOpen(false);
    if (devolverFoco) triggerRef.current?.focus?.();
  }, []);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') { e.stopPropagation(); close(true); }
    };
    const onDown = (e) => {
      const t = e.target;
      if (panelRef.current?.contains(t) || triggerRef.current?.contains(t)) return;
      close(false);
    };
    document.addEventListener('keydown', onKey);
    document.addEventListener('mousedown', onDown);
    document.addEventListener('touchstart', onDown);
    return () => {
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('touchstart', onDown);
    };
  }, [open, close]);

  return { open, setOpen, close, triggerRef, panelRef, toggle: () => setOpen((v) => !v) };
}

/** Setas ↑/↓ entre os itens focáveis de um menu (role="menu"/listbox). */
export function moverFocoNoMenu(e, container) {
  if (!container || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Home' && e.key !== 'End')) return;
  const itens = [...container.querySelectorAll('[role="menuitem"],[role="menuitemcheckbox"],[role="option"],button.sp-popover-item')]
    .filter((el) => !el.disabled);
  if (!itens.length) return;
  e.preventDefault();
  const i = itens.indexOf(document.activeElement);
  let n;
  if (e.key === 'Home') n = 0;
  else if (e.key === 'End') n = itens.length - 1;
  else if (e.key === 'ArrowDown') n = i < 0 ? 0 : (i + 1) % itens.length;
  else n = i <= 0 ? itens.length - 1 : i - 1;
  itens[n].focus();
}
